(function( app, partnerForm, $, undefined ) {
  'use strict';

  const autocompleteEndpoints = {
    'collections': '/admin/api/v1/collections'
  }
  const formElements = {
    'collections_selector': '.collection_id_input'
  }

  // Public Method
  partnerForm.initForm = function() {
    _initCollectionSelections()

    // Bound once, on ActiveAdmin's post-insert event, so the new fieldset is already in
    // the DOM. Binding inside _initCollectionSelections would re-bind on every add,
    // doubling the handlers each time.
    $(document).on('has_many_add:after', '.has_many_container', _initCollectionSelections)
  }

  // The select carries `default-select`, which makes activeadmin_addons skip it, so this
  // is the only Select2 instance on the element -- no stacked duplicate to undo.
  //
  // Initialised per element so each ajax call can read its own data-partner-id, which
  // scopes the autocomplete to collections flagged for this partner.
  function _initCollectionSelections() {
    $(formElements['collections_selector']).each(function () {
      var $select = $(this)

      // Ours is the only instance on the element, so an already-initialised select is one
      // we handled on a previous pass -- skip it rather than stacking a second.
      if ($select.hasClass('select2-hidden-accessible')) {
        return
      }

      $select.select2({
        placeholder: 'Select Collection ...',
        allowClear: false,
        minimumInputLength: 3,
        ajax: {
          url: autocompleteEndpoints['collections'],
          dataType: 'json',
          data: function (params) {
            // Query parameters will be ?search=[term]&partner_id=[id]
            var query = {
              search: params.term,
              partner_id: $select.data('partnerId')
            }
            return query;
          },
          processResults: function (data) {
            return {
              results: data
            };
          }
        }
      })
    })
  }
}(window.app ||= {},
  window.app.partnerForm ||= {},
  jQuery
));

(function ($) {
  $(function() {
    // INIT the Partner - New/Edit Page
    if ($('#new_partner').length || $('#edit_partner').length) {
      app.partnerForm.initForm();
    }
  })
})(jQuery);
